import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/buyers/')({
  beforeLoad: () => {
    throw redirect({ to: '/customers' });
  },
});
